import { makeApi } from "@zodios/core";
import { z } from "zod";

const spApiOAuthRequestSchema = z.object({
  spapi_oauth_code: z.string(),
  selling_partner_id: z.string(),
  region: z.enum(["NA", "EU", "FE"]),
});

// Backend returns empty body on success - status code indicates success/failure
const spApiOAuthResponseSchema = z.unknown();

// Error responses from the backend
const spApiOAuthErrorSchema = z.string();

export const spApiOAuthApiDefinitions = makeApi([
  {
    alias: "exchangeSpApiCode",
    method: "post",
    path: "/api/amazonspapi/",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: spApiOAuthRequestSchema,
      },
    ],
    response: spApiOAuthResponseSchema,
    errors: [
      {
        status: 400,
        schema: spApiOAuthErrorSchema,
      },
      {
        status: 500,
        schema: spApiOAuthErrorSchema,
      },
    ],
  },
]);
